// Enum for table columns (API response fields)
export enum LeadTableColumn {
  SALES_LEAD_ID = "sales_lead_id",
  LEAD_NAME = "lead_name",
  COMPANY_NAME = "company_name",
  REGION_NAME = "region_name",
  PHONE = "phone",
  EMAIL = "email",
  TYPE_NAME = "type_name",
  INDUSTRY_NAME = "industry_name",
  ENQUIRY_CATEGORY_NAME = "enquiry_category_name",
  STATUS = "status",
}

// Enum for export columns (backend expected fields)
export enum LeadExportColumn {
  SALES_LEAD_ID = "sales_lead_id",
  LEAD_NAME = "lead_name",
  COMPANY_NAME = "company_name",
  REGION_NAME = "region__name",
  PHONE = "phone",
  EMAIL = "email",
  TYPE_NAME = "type__name",
  INDUSTRY_NAME = "industry__name",
  ENQUIRY_CATEGORY_NAME = "enquiry_category__name",
  STATUS_TITLE_NAME = "status_title_name",
}

// Column display names mapping (for UI)
export const LeadColumnLabels: Record<LeadTableColumn, string> = {
  [LeadTableColumn.SALES_LEAD_ID]: "Code",
  [LeadTableColumn.LEAD_NAME]: "Lead Name",
  [LeadTableColumn.COMPANY_NAME]: "Company",
  [LeadTableColumn.REGION_NAME]: "Region",
  [LeadTableColumn.PHONE]: "Contact",
  [LeadTableColumn.EMAIL]: "Email",
  [LeadTableColumn.TYPE_NAME]: "Type",
  [LeadTableColumn.INDUSTRY_NAME]: "Industry",
  [LeadTableColumn.ENQUIRY_CATEGORY_NAME]: "Category",
  [LeadTableColumn.STATUS]: "Status",
};

// Default selected columns for export (all true)
export const getDefaultLeadSelectedColumns = () => ({
  [LeadExportColumn.SALES_LEAD_ID]: true,
  [LeadExportColumn.LEAD_NAME]: true,
  [LeadExportColumn.COMPANY_NAME]: true,
  [LeadExportColumn.REGION_NAME]: true,
  [LeadExportColumn.PHONE]: true,
  [LeadExportColumn.EMAIL]: true,
  [LeadExportColumn.TYPE_NAME]: true,
  [LeadExportColumn.INDUSTRY_NAME]: true,
  [LeadExportColumn.ENQUIRY_CATEGORY_NAME]: true,
  [LeadExportColumn.STATUS_TITLE_NAME]: true,
});
